import { z } from 'zod'
import { Log } from '../../common/logging'
import { isNullish } from '../../common/type-utils'

const PDF_LOGO_POSITION = ['left', 'right'] as const
const PDF_ADDRESS_ORDER = ['service-first', 'billing-first'] as const

type PdfLogoPosition = (typeof PDF_LOGO_POSITION)[number]
type PdfAddressOrder = (typeof PDF_ADDRESS_ORDER)[number]

export const PdfLayoutConfigSchema = z.object({
  header: z
    .object({
      logoPosition: z.enum(PDF_LOGO_POSITION).default('left'),
    })
    .default({}),
  address: z
    .object({
      order: z.enum(PDF_ADDRESS_ORDER).default('service-first'),
      showPhoneNumbers: z.boolean().default(true),
      showSameAsAddressText: z.boolean().default(true),
    })
    .default({}),
})

export type PdfLayoutConfig = z.infer<typeof PdfLayoutConfigSchema>

// Make DEFAULT_PDF_LAYOUT_CONFIG equivalent to the defaults on the schema itself
export const DEFAULT_PDF_LAYOUT_CONFIG: PdfLayoutConfig = PdfLayoutConfigSchema.parse({})

export const parsePdfLayoutConfig: (input: unknown) => PdfLayoutConfig = input => {
  if (isNullish(input)) {
    return DEFAULT_PDF_LAYOUT_CONFIG
  }

  const parsedConfig = PdfLayoutConfigSchema.safeParse(input)
  if (parsedConfig.success) {
    return parsedConfig.data
  }

  Log.warn('Invalid pdfLayoutConfig, using defaults', {
    input,
    errors: parsedConfig.error.errors,
  })

  return DEFAULT_PDF_LAYOUT_CONFIG
}
